import { message, PageHeader, Select, Space, Spin, Table, Tabs, Tag, Tooltip, Typography } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  SelectItem,
  Form,
  FormItem,
  RangePickerItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem,
} from "../../../../Components/Items";
import { FileExcelOutlined } from "@ant-design/icons";
import moment from "moment";
import "moment/locale/es";
import { fmtFechaHoraMexico } from "../../../../Components/fechaHoraMexico";
import { descargarExcel } from "./exportarReferenciasPago";

moment.locale("es");

const { Option } = Select;
const { TabPane } = Tabs;

// Mismas claves que METODOS en reporteReferenciasPagoEscuela.controllers.js
const METODOS = [
  { valor: "transferenciaEscuela", etiqueta: "Transferencia a cuenta de la escuela" },
  { valor: "oxxo", etiqueta: "OXXO (Conekta)" },
  { valor: "spei", etiqueta: "SPEI (Conekta)" },
  { valor: "conekta", etiqueta: "Conekta (otro)" },
  { valor: "mattildaEfectivo", etiqueta: "Efectivo (Mattilda)" },
  { valor: "mattildaTransferencia", etiqueta: "Transferencia (Mattilda)" },
  { valor: "mattilda", etiqueta: "Mattilda (otro)" },
];

const ESTADOS = [
  { valor: "Pendiente", color: "blue" },
  { valor: "Vencida", color: "orange" },
  { valor: "Pagada", color: "green" },
  { valor: "Cancelada", color: "red" },
];
const COLOR_ESTADO = new Map(ESTADOS.map((e) => [e.valor, e.color]));

const OPCIONES_REFERENCIA = [
  { valor: "todos", etiqueta: "Todos los alumnos" },
  { valor: "con", etiqueta: "Solo con referencia" },
  { valor: "sin", etiqueta: "Solo sin referencia" },
];

// Funcion y no constante: Panel importa esta pagina al arrancar la app, y un
// moment() a nivel de modulo dejaria fijo el mes en que se abrio el sistema.
const valoresIniciales = () => ({
  periodo: [moment().startOf("month"), moment().endOf("month")],
  escuelas: [],
  grupos: [],
  metodos: [],
  estados: [],
  conReferencia: "todos",
});

const fechaDia = (valor) => fmtFechaHoraMexico(valor).slice(0, 10);

class ReporteReferenciasPago extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    filas: [],
    totales: null,
    empresa: null,
    escuelas: [],
    grupos: [],
    escuelasSeleccionadas: [],
    descripcionFiltros: "",
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post(
        "reportesEscuela/catalogosReporteAlumnos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            escuelas: res.data.escuelas || [],
            grupos: res.data.grupos || [],
          });
        }
      })
      .catch(() => {});

    this.consultarReporte(valoresIniciales());
  }

  describirFiltros(values) {
    const nombres = (ids, catalogo) => {
      const porId = new Map(catalogo.map((c) => [String(c._id), c.nombre]));
      return (ids || []).map((id) => porId.get(String(id)) || "").filter(Boolean).join(", ");
    };
    const etiquetasMetodo = new Map(METODOS.map((m) => [m.valor, m.etiqueta]));
    const partes = [
      `Periodo: ${values.periodo[0].format("DD/MM/YYYY")} al ${values.periodo[1].format("DD/MM/YYYY")}`,
      `Escuelas: ${nombres(values.escuelas, this.state.escuelas) || "Todas"}`,
      `Grupos: ${nombres(values.grupos, this.state.grupos) || "Todos"}`,
      `Metodo: ${(values.metodos || []).map((m) => etiquetasMetodo.get(m)).join(", ") || "Todos"}`,
      `Estado: ${(values.estados || []).join(", ") || "Todos"}`,
      `Alumnos: ${
        OPCIONES_REFERENCIA.find((o) => o.valor === (values.conReferencia || "todos")).etiqueta
      }`,
    ];
    return partes.join(" | ");
  }

  consultarReporte(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesEscuela/reporteReferenciasPago",
        {
          empresaId: this.props.empresaId,
          fechaInicial: values.periodo[0].startOf("day").toISOString(),
          fechaFinal: values.periodo[1].endOf("day").toISOString(),
          escuelas: values.escuelas || [],
          grupos: values.grupos || [],
          metodos: values.metodos || [],
          estados: values.estados || [],
          conReferencia: values.conReferencia || "todos",
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            filas: res.data.filas || [],
            totales: res.data.totales,
            empresa: res.data.empresa,
            descripcionFiltros: this.describirFiltros(values),
            loading: false,
          });
        } else {
          message.error(res.data.err || "Ha sucedido un error y no se cargo bien el reporte");
          this.setState({ loading: false, filas: [], totales: null });
        }
      })
      .catch(() => {
        message.error("Ha sucedido un error y no se cargo bien el reporte");
        this.setState({ loading: false });
      });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  // Los grupos se acotan a las escuelas elegidas para no listar cientos de opciones.
  gruposVisibles() {
    const { grupos, escuelasSeleccionadas } = this.state;
    if (!escuelasSeleccionadas || escuelasSeleccionadas.length === 0) return grupos;
    const permitidas = new Set(escuelasSeleccionadas.map(String));
    return grupos.filter((g) => permitidas.has(String(g.escuelaId)));
  }

  onChangeEscuelas = (valores) => {
    const permitidas = new Set((valores || []).map(String));
    const gruposActuales = this.formRef.current?.getFieldValue("grupos") || [];
    // Si se acota la lista de escuelas, se limpian los grupos que ya no pertenecen.
    if (permitidas.size > 0 && gruposActuales.length > 0) {
      const gruposPorId = new Map(this.state.grupos.map((g) => [String(g._id), g]));
      const gruposValidos = gruposActuales.filter((id) =>
        permitidas.has(String(gruposPorId.get(String(id))?.escuelaId))
      );
      if (gruposValidos.length !== gruposActuales.length) {
        this.formRef.current?.setFieldsValue({ grupos: gruposValidos });
      }
    }
    this.setState({ escuelasSeleccionadas: valores || [] });
  };

  render() {
    const { filas, totales } = this.state;

    const columns = [
      {
        title: "Referencia",
        dataIndex: "referencia",
        key: "referencia",
        width: 190,
        fixed: "left",
        render: (v, record) =>
          record.sinReferencia ? (
            <span style={{ color: "#8c8c8c", fontStyle: "italic" }}>Sin referencia</span>
          ) : (
            <Typography.Text code copyable={{ text: v }}>
              {v}
            </Typography.Text>
          ),
      },
      { title: "Método", dataIndex: "metodoEtiqueta", key: "metodoEtiqueta", width: 240, ellipsis: true },
      {
        title: "Estado",
        dataIndex: "estadoReferencia",
        key: "estadoReferencia",
        width: 120,
        render: (v, record) => {
          if (!v) return "";
          const tag = <Tag color={COLOR_ESTADO.get(v)}>{v}</Tag>;
          return record.motivoCancelacion ? (
            <Tooltip title={record.motivoCancelacion}>{tag}</Tooltip>
          ) : (
            tag
          );
        },
      },
      {
        title: "Generada",
        dataIndex: "fechaGeneracion",
        key: "fechaGeneracion",
        width: 140,
        render: (v) => fmtFechaHoraMexico(v),
      },
      {
        title: "Vence",
        dataIndex: "fechaVence",
        key: "fechaVence",
        width: 140,
        render: (v) => fmtFechaHoraMexico(v),
      },
      {
        title: "Fecha De Pago",
        dataIndex: "fechaPago",
        key: "fechaPago",
        width: 120,
        render: (v) => fechaDia(v),
      },
      { title: "Folio Venta", dataIndex: "folio", key: "folio", width: 120 },
      {
        title: "Total A Pagar",
        dataIndex: "totalPagar",
        key: "totalPagar",
        width: 140,
        align: "right",
        render: (v) => (v || v === 0 ? dineroDisabledMask(v) : ""),
      },
      { title: "Matrícula(s)", dataIndex: "matriculas", key: "matriculas", width: 150, ellipsis: true },
      { title: "Alumno(s)", dataIndex: "alumnos", key: "alumnos", width: 280, ellipsis: true },
      { title: "Escuela(s)", dataIndex: "escuelas", key: "escuelas", width: 200, ellipsis: true },
      { title: "Grupo(s)", dataIndex: "grupos", key: "grupos", width: 140, ellipsis: true },
      { title: "Paquete(s)", dataIndex: "paquetes", key: "paquetes", width: 220, ellipsis: true },
      { title: "Generada Por", dataIndex: "generadaPor", key: "generadaPor", width: 220, ellipsis: true },
      { title: "Correo", dataIndex: "correo", key: "correo", width: 220, ellipsis: true },
      { title: "Teléfono", dataIndex: "telefono", key: "telefono", width: 130 },
    ];

    const t = totales || {};
    const resumen = [
      { etiqueta: "Referencias", valor: t.referencias || 0 },
      { etiqueta: "Pagadas", valor: t.pagadas || 0 },
      { etiqueta: "Pendientes", valor: t.pendientes || 0 },
      { etiqueta: "Vencidas", valor: t.vencidas || 0 },
      { etiqueta: "Canceladas", valor: t.canceladas || 0 },
      { etiqueta: "Total generado", valor: dineroDisabledMask(t.totalGenerado || 0) },
      { etiqueta: "Total cobrado", valor: dineroDisabledMask(t.totalCobrado || 0) },
      { etiqueta: "Por cobrar", valor: dineroDisabledMask(t.totalPorCobrar || 0) },
      { etiqueta: "Alumnos sin referencia", valor: t.alumnosSinReferencia || 0 },
    ];

    return (
      <>
        <Form
          ref={this.formRef}
          name="reporteReferenciasPago"
          onFinish={this.consultarReporte.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={valoresIniciales()}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte de Referencias de Pago"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {filas.length > 0 && (
                    <ButtonItem
                      blanco
                      onClick={() =>
                        descargarExcel({
                          filas,
                          empresaNombre: this.state.empresa?.nombre || "",
                          descripcionFiltros: this.state.descripcionFiltros,
                        })
                      }
                      icon={<FileExcelOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar Excel
                    </ButtonItem>
                  )}
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                marginBottom: 10,
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1>,
                }}
              >
                <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                  <FormItem name="periodo" required noStyle>
                    <RangePickerItem />
                  </FormItem>
                </TabPane>
                <TabPane tabKey="2" key="2" forceRender tab="Escuelas">
                  <FormItem name="escuelas" noStyle margin>
                    <SelectItem
                      width="90%"
                      mode="multiple"
                      placeholder="Todas las escuelas"
                      onChange={this.onChangeEscuelas}
                    >
                      {this.state.escuelas.map((escuela) => (
                        <Option value={escuela._id} key={escuela._id}>
                          {escuela.nombre}
                        </Option>
                      ))}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="3" key="3" forceRender tab="Grupos">
                  <FormItem name="grupos" noStyle margin>
                    <SelectItem width="90%" mode="multiple" placeholder="Todos los grupos">
                      {this.gruposVisibles().map((grupo) => (
                        <Option value={grupo._id} key={grupo._id}>
                          {grupo.nombre}
                        </Option>
                      ))}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Método">
                  <FormItem name="metodos" noStyle margin>
                    <SelectItem width="90%" mode="multiple" placeholder="Todos los métodos">
                      {METODOS.map((metodo) => (
                        <Option value={metodo.valor} key={metodo.valor}>
                          {metodo.etiqueta}
                        </Option>
                      ))}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="5" key="5" forceRender tab="Estado">
                  <FormItem name="estados" noStyle margin>
                    <SelectItem width="90%" mode="multiple" placeholder="Todos los estados">
                      {ESTADOS.map((estado) => (
                        <Option value={estado.valor} key={estado.valor}>
                          {estado.valor}
                        </Option>
                      ))}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="6" key="6" forceRender tab="Referencia">
                  <FormItem name="conReferencia" noStyle margin>
                    <SelectItem width="90%" placeholder="Todos los alumnos">
                      {OPCIONES_REFERENCIA.map((opcion) => (
                        <Option value={opcion.valor} key={opcion.valor}>
                          {opcion.etiqueta}
                        </Option>
                      ))}
                    </SelectItem>
                  </FormItem>
                </TabPane>
              </Tabs>
            </div>

            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 10,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 24,
                  marginBottom: 12,
                }}
              >
                {resumen.map((dato) => (
                  <div key={dato.etiqueta}>
                    <div style={{ fontSize: 12, color: "#8c8c8c" }}>{dato.etiqueta}</div>
                    <div style={{ fontSize: 18, fontWeight: 600 }}>{dato.valor}</div>
                  </div>
                ))}
              </div>

              {/* Table de antd directo y no TableItem: TableItem trae pagination y
                  scroll hardcodeados con tableLayout fijo, y con estas columnas
                  quedarian todas exprimidas sin scroll horizontal. */}
              <Table
                rowKey={(record) => record.key}
                columns={columns}
                dataSource={filas}
                size="small"
                bordered
                scroll={{ x: "max-content", y: "60vh" }}
                pagination={{
                  defaultPageSize: 100,
                  showSizeChanger: true,
                  showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} renglones`,
                }}
                rowClassName={(record, index) => (index % 2 === 0 ? "zebra-gris" : "default")}
              />
            </div>
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ReporteReferenciasPago);
